import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider1_Cabs({ section }) {

  function updateClassBasedOnScreenSize() {
    const element = document.querySelector(".airport-transfer");

    if (!element) return;
    if (element) {
      if (window.innerWidth >= 1024) {
        element.classList.add("my-30");
      } else {
        element.classList.remove("my-30");
      }
    }
  }

  // Run on page load and when resizing
  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);
  const [isScrolled, setIsScrolled] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1200, // For screens smaller than 1200px
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992, // For screens smaller than 992px
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For screens smaller than 768px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 320, // For screens smaller than 320px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="popular-state pt-5 holidays-left">
      <div className="container">
        <div className="title">
          <h3>{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Flexible </span>} {section?.title || 'Hourly Car Rentals in India'}</h3>
          <p className="mb-4">{section?.subtitle || 'Rent a car by the hour for convenient and affordable travel within major Indian cities. Enjoy the freedom to explore at your own pace.'}</p>
        </div>
        <div
          className={`customer-logos slider slides-wrapper airport-transfer-slide-sec ${isScrolled ? "slider" : ""
            }`}
        >
          <Slider {...settings}>
            {(section?.Items?.length ? section.Items : [
              { title: 'Hyderabad', description: 'Andhra Pradesh, India', image_url: 'https://www.easemytrip.com/cabs/img/delhi-car.png', price: '₹940', link_url: 'https://www.easemytrip.com/cabs/car-rental-delhi/' },
              { title: 'Bangalore', description: 'Karnataka, India', image_url: 'https://www.easemytrip.com/cabs/img/Bangaluru-car.png', price: '₹940', link_url: 'https://www.easemytrip.com/cabs/car-rental-delhi/' },
              { title: 'Ahmedabad', description: 'Gujarat, India', image_url: 'https://www.easemytrip.com/cabs/img/Ahmedabad-car.png', price: '₹940', link_url: 'https://www.easemytrip.com/cabs/car-rental-delhi/' },
              { title: 'Jaipur', description: 'Rajasthan, India', image_url: 'https://www.easemytrip.com/cabs/img/jaipur.png', price: '₹940', link_url: 'https://www.easemytrip.com/cabs/car-rental-delhi/' },
              { title: 'Delhi', description: 'Delhi, India', image_url: 'https://www.easemytrip.com/cabs/img/delhi-car.png', price: '₹940', link_url: 'https://www.easemytrip.com/cabs/car-rental-delhi/' },
              { title: 'Varanasi', description: 'Uttar Pradesh, India', image_url: 'https://www.easemytrip.com/cabs/img/varansi.png', price: '₹940', link_url: 'https://www.easemytrip.com/cabs/car-rental-delhi/' },
            ]).map((item, index) => (
              <div key={index}>
                <div className="post-item">
                  <div className="post__img">
                    <a href={item.link_url || '#'}>
                      <img src={item.image_url} alt={item.title} loading="lazy" />
                    </a>
                  </div>

                  <div className="post__body">
                    <div className="post__meta-cat">
                      <div className="ttl-text-book">
                        <div className="ttl-text d-flex justify-content-space-between gap-3">
                          <div className="left">
                            <h5>{item.title}</h5>
                            <p>{item.description}</p>
                          </div>
                          <div className="right">
                            <div className="img">
                              <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock" />
                            </div>
                          </div>
                        </div>
                        <div className="book-wrap">
                          <a href={item.link_url || '#'}>
                            <div className="book-list d-flex justify-content-space-between align-items-center">
                              <div className="book">
                                <p>From <span>{item.price || '₹940'}</span></p>
                              </div>
                              <div className="book-link">
                                <span className="book" onClick={() => window.scrollTo(0, 0)}>Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow" /></span>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="book-wrap">
                          <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                            <div className="book-list d-flex justify-content-space-between align-items-center">
                              <div className="book">
                                <p>From <span>₹940</span></p>
                              </div>
                              <div className="book-link">
                                <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow" /></span>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Slider1_Cabs;
